export default __webpack_public_path__ + "static/media/028.e7eab87b.jpg";